<template>
    <div class="pt-8">
        <h2 class="text-base font-medium text-gray-700 mb-1 text-center">Settings</h2>
        <div class="bg-gray-50 border border-gray-200 rounded-xl p-4">
            <table class="w-full table-fixed">
                <tbody>
                <td colspan="2" class="pt-0">
                    <div class="relative">
                        <div class="border-t border-gray-200 my-3"></div>
                        <div class="absolute inset-0 flex items-center justify-center">
                            <div class="text-xs px-2 py-1 bg-gray-50 text-gray-400 font-semibold">
                                Overheads & Profit
                            </div>
                        </div>
                    </div>
                </td>
                <tr>
                    <td colspan="2" class="text-sm text-gray-500">
                        <div class="my-1">
                            Only items that haven't been manually changed will update
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="text-sm">Overheads</td>
                    <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                        <div class="flex items-center justify-between">
                            <ui-input :disabled="estimate.readonly" v-model="overheads" @change="changeOverhead"
                                      @input="updateOverhead" field="py-0.5 text-right"
                                      placeholder="10%"></ui-input>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="text-sm">Profit</td>
                    <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                        <div class="flex items-center justify-between">
                            <ui-input :disabled="estimate.readonly" v-model="profit" @change="changeProfit"
                                      @input="updateProfit" field="py-0.5 text-right" placeholder="25%"></ui-input>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="text-sm text-gray-500">
                        <div class="my-1 ml-4">
                            <span class="text-green-600 align-text-top"><span class="fa fa-arrow-up mt-1"
                                                                              style="font-size: 9px"></span></span> =
                            Profit Higher than default
                        </div>
                        <div class="my-1 ml-4">
                            <span class="text-red-600 align-text-top"><span class="fa fa-arrow-down mt-1"
                                                                            style="font-size: 9px"></span></span> =
                            Profit Lower than default
                        </div>
                        <div class="my-1 ml-4">
                            <span class="text-blue-600 align-text-top"><span class="fas fa-star mt-1"
                                                                             style="font-size: 8px"></span></span> = No
                            costings against item
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="pt-0">
                        <div class="relative">
                            <div class="border-t border-gray-200 my-3"></div>
                            <div class="absolute inset-0 flex items-center justify-center">
                                <div class="text-xs px-2 py-1 bg-gray-50 text-gray-400 font-semibold">
                                    MCD
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="text-sm">MCD</td>
                    <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                        <div class="flex items-center justify-between">
                            <ui-input :disabled="estimate.readonly" v-model="mcd" @change="changeMcd" @input="updateMcd"
                                      field="py-0.5 text-right" placeholder="0%"></ui-input>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="pt-0">
                        <div class="relative">
                            <div class="border-t border-gray-200 my-3"></div>
                            <div class="absolute inset-0 flex items-center justify-center">
                                <div class="text-xs px-2 py-1 bg-gray-50 text-gray-400 font-semibold">
                                    Options
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="text-sm">Hide Item Costings</td>
                    <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                        <ui-toggle class="text-left inline-block w-auto p-0.5 rounded-xl" field="text-xs"
                                   v-model="estimate.settings.hideItemCostings"
                                   :disabled="estimate.readonly"
                                   @input="toggleCostings"
                        ></ui-toggle>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

import {Estimate} from "../../../models";
import {resolveNumericText} from "../../../utils";
import UiToggle from "../../ui/UiToggle.vue";

export default {
    components: {UiToggle},
    props: {
        estimate: Estimate,
        resolveNumericText,
    },
    data() {
        return {
            'profit': this.estimate.profit + '%',
            'overheads': this.estimate.overheads + '%',
            'mcd': this.estimate.mcd + '%',
        }
    },
    methods: {
        toggleCostings(o) {
            this.estimate.update()
        },
        changeOverhead(o) {
            this.estimate.updateOverheads(Math.round(Math.max(resolveNumericText(o)) * 100) / 100);
            this.overheads = this.estimate.overheads + '%';
        },
        updateOverhead(o) {
            this.estimate.updateOverheads(Math.round(Math.max(resolveNumericText(o)) * 100) / 100);
            this.estimate.update()
        },
        changeProfit(o) {
            this.profit = this.estimate.profit + '%';
        },
        updateProfit(o) {
            this.estimate.profit = Math.round(Math.max(resolveNumericText(o)) * 100) / 100;
            this.estimate.update();
        },
        changeMcd(o) {
            this.mcd = this.estimate.mcd + '%';
        },
        updateMcd(o) {
            this.estimate.mcd = Math.round(Math.max(Math.min(100, resolveNumericText(o)), 0) * 100) / 100;
            this.estimate.update();
        }
    },
}
</script>
